module.exports = __webpack_public_path__ + "static/media/organisationMobile.b149099a.png";